import { createClient } from 'contentful';

const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: 'proxy',
  host: process.env.REACT_APP_CONTENTFUL_HOST,
  environment: 'master',
});

export default client;
